import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  keyword: "",
  loading: false,
  sortConfig: {
    key: "createdAt",
    direction: "ASC",
  },
  listRegion: [],
  listArea: [],
};

export const Office = createSlice({
  name: "office",
  initialState,
  reducers: {
    ChangeData: (state, action) => {
      state.data = action.payload;
    },
    ChangeKeyword: (state, action) => {
      state.keyword = action.payload;
    },
    ChangeLoading: (state, action) => {
      state.loading = action.payload;
    },
    ChangeSortConfig: (state, action) => {
      state.sortConfig = action.payload;
    },
    ChangeListRegion: (state, action) => {
      state.listRegion = action.payload;
    },
    ChangeListArea: (state, action) => {
      state.listArea = action.payload;
    },
  },
});

export const {
  ChangeData,
  ChangeKeyword,
  ChangeLoading,
  ChangeSortConfig,
  ChangeListRegion,
  ChangeListArea,
} = Office.actions;

export default Office.reducer;
